var map = {
	"./RHandt-Kerry-Sano-Velocita-0.webp": 3312,
	"./RHandt-Kerry-Sano-Velocita-1.webp": 8763,
	"./RHandt-Velocita-Ducati-Panigale-Speciale-0.avif": 3408,
	"./RHandt-Velocita-Ducati-Panigale-Speciale-1.avif": 9064,
	"./agusta-mv.avif": 5534,
	"./bonneville-triumph.avif": 9419,
	"./brembo.avif": 1370,
	"./child-on-bike.avif": 8494,
	"./cute-dog-in-velocita.avif": 4143,
	"./doggie-love.avif": 3253,
	"./ducati-and-friends.avif": 9391,
	"./ducati-lineup.avif": 2095,
	"./ducati-repair.avif": 7039,
	"./gears.avif": 7965,
	"./honda-motorcycle.avif": 6274,
	"./motorcycle-dog.avif": 9225,
	"./motorcycle-engine.avif": 7628,
	"./motorcycle-love.avif": 2715,
	"./motorcycle-meet.avif": 3187,
	"./motorcycle-parts-1.avif": 339,
	"./motorcycle-parts-2.avif": 3598,
	"./motorcycle-parts-3.avif": 4777,
	"./motorcycle-parts-4.avif": 357,
	"./motorcycle-parts-5.avif": 9711,
	"./motorcycle-parts-6.avif": 1652,
	"./motorcycle-parts-7.avif": 7789,
	"./motorcycle-parts.avif": 6811,
	"./motorcycle-repair-1.avif": 2861,
	"./motorcycle-repair-2.avif": 3995,
	"./motorcycle-repair-3.avif": 5875,
	"./motorcycle-repair-4.avif": 9889,
	"./motorcycle-repair-5.avif": 6498,
	"./motorcycle-wheel.avif": 8636,
	"./motorcycle-wheels-1.avif": 1031,
	"./motorcycle-wheels.avif": 2617,
	"./motorcycle-with-art.avif": 904,
	"./motorcycle-with-colorful-background.avif": 797,
	"./piaa.avif": 9003,
	"./silver-red-motorcycle.avif": 1590,
	"./velocita-skull-logo.avif": 5687,
	"./white-and-red-motorcycle.avif": 7716,
	"./white-ducati.avif": 3110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1099;